// extracted by mini-css-extract-plugin
export default {"wrapper":"ToolTip_wrapper__pJ2it","tooltip":"ToolTip_tooltip__0RLAZ"};